export * from './avatar-demo.component';
